import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const CustomUiDesign = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/uiux-3.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                  <h1 id="heading_line">Custom UI Design Services: Elevate Your Digital Experience</h1>
                  <h2 id="sub_heading1">
                  At Codeflix,we provide Custom UI Design services tailored to meet your unique business needs. Our designs focus on aesthetics, usability, and seamless user interactions, ensuring that your digital product stands out in a competitive market. We understand that a well-crafted user interface can significantly impact user engagement, customer retention, and overall business success. Our team of skilled designers works diligently to create visually appealing, intuitive, and functionally superior UI solutions that drive user satisfaction and business growth.
                  </h2>
                </div>
              </div>
            </div>
          </div>
          <div className="why_coustom_app">
            <div className="wrapper">
              <h3>
              Why Choose Our Custom <span>UI Design Services ?</span>
              </h3>
                <p>A well-designed user interface is the cornerstone of any successful digital product. Our Custom UI Design Services offer tailor-made solutions that reflect your brand’s identity while enhancing the user experience. We prioritize user-centric design principles to craft engaging and intuitive interfaces that keep users coming back. Our designs are responsive and adaptive, ensuring seamless usability across all devices, from desktops to smartphones. By leveraging cutting-edge design tools and modern frameworks, we create high-performing interfaces that align with the latest industry trends. Moreover, our UI designs are optimized to boost conversion rates, helping you turn visitors into loyal customers by making navigation simple and effective.</p>
                <h3><span>Our Custom UI Design Process</span></h3>
                <h4>1. Understanding Your Vision</h4>
                <p>A successful UI design begins with a deep understanding of your business goals and user expectations. Our team conducts thorough research, collaborating closely with stakeholders to gather insights into user behavior, industry trends, and competitor analysis. This helps us create a strategic foundation that guides the design process, ensuring that the final UI aligns with your business objectives and customer needs. By taking a data-driven approach, we ensure that our UI solutions provide maximum value to both businesses and end users.</p>
                <h4>2. Wireframing & Prototyping</h4>
                <p>Before finalizing the design, we create wireframes and interactive prototypes that serve as blueprints for the user interface. Wireframes help in defining the structure and layout of key elements, ensuring a logical user flow and smooth navigation. Prototyping allows us to bring static designs to life, enabling stakeholders and users to interact with the interface before development begins. This step helps in gathering early feedback, making necessary refinements, and ensuring an optimized user experience from the outset.</p>
                <h4>3. Visual Design & Branding</h4>
                <p>The visual appeal of a UI plays a crucial role in user engagement. Our team focuses on color psychology, typography, iconography, and other branding elements to create visually compelling interfaces that resonate with your brand identity. We ensure that every UI element contributes to a cohesive and aesthetically pleasing digital experience while maintaining accessibility and usability standards. Whether you need a sleek, modern interface or a vibrant and dynamic design, our team ensures that your UI is aligned with your brand’s voice and audience preferences.</p>
                <h4>4. UI Development & Implementation Support</h4>
                <p>Beyond design, we work closely with development teams to ensure seamless UI implementation. We provide detailed style guides, design systems, and component libraries that streamline the development process. Our collaboration with front-end developers ensures that every UI element is translated into a fully functional digital experience without losing design integrity. By implementing scalable and modular UI components, we help businesses build interfaces that are future-proof and easy to maintain.</p>
                <h4>5. Usability Testing & Refinements</h4>
                <p>A great UI is one that is continuously refined based on user feedback and performance analysis. We conduct A/B testing, heatmap analysis, and usability testing to identify potential pain points and areas for improvement. By gathering real-time user insights, we fine-tune UI elements to enhance usability and engagement. Our iterative approach ensures that your UI remains optimized, intuitive, and aligned with user expectations.</p>
                <h3><span>Tools & Technologies We Use</span></h3>
                <p>We leverage industry-leading design tools and front-end technologies to create stunning UI designs that are both functional and visually appealing. Our toolkit includes Figma and Adobe XD for collaborative UI design and prototyping, Sketch and InVision for high-fidelity design solutions, and HTML, CSS, JavaScript for front-end UI implementation. For advanced UI development, we work with React and Vue.js, ensuring dynamic, scalable, and interactive user interfaces that enhance the overall user experience.</p>
                <h3><span>Industries We Serve</span></h3>
                <p>Our Custom UI Design Services cater to businesses across multiple industries, each with unique challenges and requirements. For E-commerce & Retail, we create visually appealing and user-friendly interfaces that enhance the shopping experience, improve product discoverability, and boost conversion rates. In Healthcare & Telemedicine, we design accessible and intuitive interfaces that facilitate seamless interactions between patients and healthcare providers. Our Finance & FinTech UI solutions focus on security, clarity, and ease of use, ensuring that users can manage transactions effortlessly. For Education & E-learning, we develop engaging and interactive digital learning platforms that promote student engagement. Additionally, for SaaS & Technology, we craft scalable UI designs that support complex functionalities while maintaining simplicity and ease of use.</p>
                <h3><span>Get Started with Us!</span></h3>
                <p>Enhance your digital presence with a custom, user-friendly, and high-performing UI. Our team at info@codeflixweb.com is ready to create visually stunning and functional UI designs that align with your business vision. Whether you need a complete UI overhaul or a fresh design for your upcoming product, we are here to help. Contact us today at info@codeflixweb.com to discuss your project and take the first step toward creating an exceptional user experience!</p>
            </div>
            
          </div>
          <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
                  </div>
                <div className="let_build">
                    <div className="wrapper">
                    <h4>Let’s Build <span> Your App Together </span></h4>
                  
                  <p>
                    Whether you’re a startup looking to disrupt the market or an
                    established enterprise aiming to enhance operational efficiency,
                    CodeFlix is here to bring your vision to life. Let’s create a
                    custom mobile app that drives results and delights your users.{" "}
                    <br />
                    Contact Us today to get started on your mobile app development
                    journey.
                  </p>
                    </div>
                </div>
        </>
      );
};
export default CustomUiDesign;
